const darkBlue = `#007acc`
// const lightBlue = `#66E0FF`
const blueGray = `#282c35`
const darkGray = `#f7f7f7`

const theme = {
  colors: {
    text: blueGray,
    primary: darkBlue,
    heading: blueGray,
    background: darkGray
  },
  styles: {
    h1: {
      fontFamily: "Longcang",
    },
    p: {
      fontFamily: "Longcang",
      fontSize: 4
    }
  }
}

export default theme;